import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const KsaMobilyMixin = {
  extends: BaseIntegration,
};

export default KsaMobilyMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/ksaMobilyIntegration.js